import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FinanceAPCollectiveInvoiceActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/CollectiveInvoice/CollectiveInvoiceBrowser")
	}

	render() {
		return (
			<Activity 
				name="FinanceAPCollectiveInvoice"
				RenderedComponent={this.RenderedComponent}
				context="FinanceAPCollectiveInvoice"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FinanceAPCollectiveInvoiceActivity)
